import { useEffect, useContext, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import {
  getData,
  getUserProfileData,
  storeData,
} from "../../../../Diathrive/src/utils/GeneralStorage";
import {
  KEYS,
  USER_AUTH_STATUS,
} from "../../../../Diathrive/src/utils/Constants";
import { eligibilityCheckContext } from "../../../../Diathrive/src/contexts/EligibilityCheckContext";
import moment from "moment";
import { accountStatusContext } from "../../../../Diathrive/src/contexts/AccountStatusContext";
import { compareTokenVersions } from "../../../../Diathrive/src/utils/HelperMethods";

const ParentRoute = ({ takeToLogin }) => {
  //This is en empty component only to expose the navigate functionality. The code here is triggered no matter the route.
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  const ecc = useContext(eligibilityCheckContext);
  const asc = useContext(accountStatusContext);

  useEffect(() => {
    if (takeToLogin) {
      navigate("/login", { state: "Token Expired" }); //take to login upon trigger by axios
    } else {
      checkLogin();
    }
  }, [takeToLogin]);

  async function checkLogin() {
    try {
      const isLogin = await getData(KEYS.isLogin);
      const token = await getData(KEYS.userToken);
      if (isLogin === USER_AUTH_STATUS.login && token) {
        const isTokenVersionUpdated = await compareTokenVersions();
        if (isTokenVersionUpdated) {
          setIsAuthenticated(true);
          setIsChecking(false);
          asc.getUserAccountStatus();
          getEligibilityCheck();
        } else {
          navigateToLogin();
        }
      } else {
        navigateToLogin();
      }
    } catch (error) {
      navigateToLogin();
    }
  }

  function navigateToLogin() {
    setIsAuthenticated(false);
    setIsChecking(false);
    navigate("/login", { state: "Token Expired" });
  }

  async function getEligibilityCheck() {
    const profile = await getUserProfileData();
    //checking user employer needs eligibility check or not
    if (profile?.employer?.realtimeFlowId === 0) {
      //redirecting to normal flow if user employer doesn't need eligibility check
      await storeData(KEYS.userEligible, "true");
      ecc.setIsEligible(true);
    } else {
      //checking Eligibilty based on employer realtimeFlowId
      const lastEligibilityCheckTime = await getData(
        KEYS.lastEligibilityCheckTime
      );

      if (lastEligibilityCheckTime) {
        const diffInHours = moment().diff(
          moment(lastEligibilityCheckTime),
          "hours"
        );

        if (diffInHours > 72) {
          checkUserEligibility(profile);
        } else {
          const isEligible = await getData(KEYS.userEligible);
          ecc.setIsEligible(isEligible === "true");
        }
      } else {
        checkUserEligibility(profile);
      }
    }
  }

  //checking Eligibilty based on employer realtimeFlowId
  function checkUserEligibility(profile) {
    ecc.checkEligibilty(
      navigate,
      profile.firstname + " " + profile.lastname,
      profile.email,
      profile.dateOfBirth,
      profile.subscriberId,
      profile?.employer?.realtimeFlowId
    );
  }

  // Don't render anything while checking authentication
  if (isChecking) {
    return null;
  }

  // Only render protected routes if authenticated
  return isAuthenticated ? <Outlet /> : null;
};

export default ParentRoute;
